"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UITextToolbarSelect = _interopRequireDefault(require("UIComponents/editor/UITextToolbarSelect"));

var _StyleProtectedSelectItem = _interopRequireDefault(require("../style-protected/StyleProtectedSelectItem"));

var _withDisabledContext = _interopRequireDefault(require("../hoc/withDisabledContext"));

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.formatting.FontSize." + suffix;
};

var FontSizeSelect =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FontSizeSelect, _Component);

  function FontSizeSelect() {
    (0, _classCallCheck2.default)(this, FontSizeSelect);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FontSizeSelect).apply(this, arguments));
  }

  (0, _createClass2.default)(FontSizeSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fontSizes = _this$props.fontSizes,
          value = _this$props.value,
          onChange = _this$props.onChange,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["fontSizes", "value", "onChange"]);
      return _react.default.createElement(_UITextToolbarSelect.default, (0, _extends2.default)({}, rest, {
        searchable: false,
        options: fontSizes,
        onChange: onChange,
        value: value,
        placeholder: _I18n.default.text(i18nKey('placeholder')),
        optionRenderer: function optionRenderer(option) {
          return _react.default.createElement(_StyleProtectedSelectItem.default, {
            className: "fontsize-select-label private-typeahead-result-label",
            title: option.text
          }, option.text);
        }
      }));
    }
  }]);
  return FontSizeSelect;
}(_react.Component);

FontSizeSelect.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  value: _react.PropTypes.string,
  fontSizes: _react.PropTypes.array.isRequired
};

var _default = (0, _withDisabledContext.default)(FontSizeSelect);

exports.default = _default;
module.exports = exports.default;